import { useContext } from 'react';
import { StyleContext } from '../context/DialogStyleContext';
export const useDialogStylesContext = () => useContext(StyleContext);